import { parse } from 'yaml';

export function safeYAMLParse(value: string): unknown | null {
  try {
    return parse(value);
  } catch (e) {
    return null;
  }
}
